/**
 * NicknameGenerator — Fantasy name generator.
 * Generates classic RPG/Nintendo/Sega-style character names.
 * Each session/tab gets a fresh random name. Only user-edited names persist
 * via localStorage (so two tabs in the same browser get different names).
 */

const STORAGE_KEY = 'trixel_player_nickname_custom';

// Standalone fantasy names — feel like actual character names
const NAMES = [
  // Classic RPG hero names
  'Aelric', 'Brynn', 'Cael', 'Darion', 'Elara', 'Fenris', 'Galen',
  'Haldor', 'Isolde', 'Jarek', 'Kael', 'Lyra', 'Mira', 'Nyx',
  'Orion', 'Phaedra', 'Quinn', 'Riven', 'Sable', 'Theron',
  'Ulric', 'Vex', 'Wren', 'Xael', 'Yara', 'Zephyr',
  // Nintendo/Sega vibes
  'Blitz', 'Cosmo', 'Drift', 'Echo', 'Flint', 'Grit', 'Hex',
  'Jinx', 'Knox', 'Link', 'Mako', 'Nash', 'Onyx', 'Pike',
  'Raze', 'Sora', 'Thorn', 'Vale', 'Wisp', 'Zara',
  // Fantasy compound names
  'Ashwind', 'Brightforge', 'Cinderveil', 'Dawnstrider', 'Emberlark',
  'Frostpine', 'Gloomheart', 'Hollowmere', 'Ironvale', 'Jadecrest',
  'Keenblade', 'Lichbloom', 'Moonhollow', 'Nighthawk', 'Oakheart',
  'Pyreveil', 'Quickthorn', 'Ravenspire', 'Stormveil', 'Thornwick',
  'Underholme', 'Voidwalker', 'Windshear', 'Yarrowmist', 'Zenithfall',
  // Short punchy
  'Ace', 'Bolt', 'Cinder', 'Dusk', 'Edge', 'Fable', 'Glint',
  'Haze', 'Ivory', 'Jade', 'Kira', 'Lark', 'Moss', 'Nimbus',
  'Opal', 'Prism', 'Quill', 'Rust', 'Shade', 'Trace',
];

const NicknameGenerator = {
  /** Generate a random fantasy name using browser CSPRNG. */
  generate() {
    return NAMES[Math.floor(Math.random() * NAMES.length)];
  },

  /**
   * Load a user-customized nickname from localStorage, or generate a fresh one.
   * Auto-generated names are NOT saved — each tab gets a unique random name.
   * Only explicitly set names (via save()) persist across sessions.
   */
  getOrCreate() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && stored.trim()) return stored.trim();
    } catch { /* localStorage unavailable */ }
    // No user-set name — generate fresh (not saved, so each tab differs)
    return this.generate();
  },

  /** Persist a user-chosen nickname to localStorage. */
  save(nick) {
    try {
      localStorage.setItem(STORAGE_KEY, nick);
    } catch { /* localStorage unavailable */ }
  },
};

export default NicknameGenerator;
